<template>
  <div><policies product="KVKK"></policies></div>
</template>

<script>
import policies from "./policies.vue";
export default {
  components: { policies },
};
</script>
